import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage.js";
import MRStore from "./pages/MRStore.js";
import UploadPage from "./pages/UploadPage.js";
import MRDemoPage from "./pages/MRDemoPage.js";
import AboutUs from "./pages/AboutUs.js";
import Logo from './assets/Logo.png';
import Popup from './Popup.js';
import { auth } from "./Config/firebase.js";
import "./App.css";

const App = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleRef = useRef(null);
  const touchStartX = useRef(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsSignedIn(!!user);
    });

    const handleOutsideClick = (e) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        toggleRef.current &&
        !toggleRef.current.contains(e.target)
      ) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      unsubscribe();
      document.removeEventListener("click", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [isMenuOpen]);

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleLogout = () => {
    auth.signOut();
  };

  const handleCreateStoreClick = () => {
    if (!isSignedIn) {
      setShowPopup(true);
    } else {
      window.location.href = "/upload";
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    if (!touchStartX.current) return;
    const touchEndX = e.touches[0].clientX;
    const diffX = touchStartX.current - touchEndX;
    if (diffX > 50) { // Swipe left threshold
      closeMenu();
    }
  };

  const handleTouchEnd = () => {
    touchStartX.current = null;
  };

  return (
    <BrowserRouter>
      <nav className="nav">
        <div className="nav-logo-container">
          <Link to="/" onClick={closeMenu} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
            <img src={Logo} alt="Xyronis Logo" style={{ height: '80px' }} />
            <span className="company-name">Xyronis</span>
          </Link>
        </div>
        <div
          className={`nav-toggle-label ${isMenuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          ref={toggleRef}
        >
          ☰
        </div>
        <div
          className={`nav-links ${isMenuOpen ? 'open' : ''}`}
          ref={menuRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
          <Link to="/mr-store" className="nav-link" onClick={closeMenu}>MR Store Demo</Link>
          <a
            onClick={(e) => {
              handleCreateStoreClick();
              closeMenu();
            }}
            className="nav-link"
            style={{ cursor: 'pointer' }}
          >
            Create MR Store
          </a>
          <Link to="/about" className="nav-link" onClick={closeMenu}>About Us</Link>
          {isSignedIn ? (
            <a
              onClick={(e) => {
                handleLogout();
                closeMenu();
              }}
              className="nav-link"
              style={{ cursor: 'pointer' }}
            >
              Log Out <span>🚪</span>
            </a>
          ) : (
            <button className="cta-button" onClick={(e) => { handleOpenPopup(); closeMenu(); }}>
              Get Started
            </button>
          )}
        </div>
      </nav>
      {showPopup && <Popup onClose={handleClosePopup} />}
      <Routes>
        <Route path="/" element={<HomePage onOpenPopup={handleOpenPopup} />} />
        <Route path="/mr-store" element={<MRStore />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/mr-demo" element={<MRDemoPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/upload.html" element={<Navigate to="/upload" replace />} />
        <Route path="/mr-demo.html" element={<Navigate to="/mr-demo" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;